window.NumeroPedidoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-numero-pedido",

    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
    },

    events: {
        'click #button-novo-orcamento': "novoOrcamento",
        'click #button-imprimir-orcamento': "imprimirOrcamento",
        'click #editar-orcamento-orcamento-concluido': "editarOrcamento",
    },

    render: function() {

        this.$el.html(Mustache.render($(this.template).html(), this.model.toJSON()));
    },

    novoOrcamento: function () {
        $(window).attr("permitirSairView", true);

        var tipoOrcamento = this.model.get("TipoOrcamento");
        if (typeof tipoOrcamento == "undefined")
            tipoOrcamento = 0;
        window.location.href = "/Orcamento/IncluirOrcamento?tipoOrcamento="+tipoOrcamento;
    },

    editarOrcamento: function () { //FNX-3817
        $(window).attr("permitirSairView", true); 

        var self = this;
        var numeroPedido = this.model.get("Numero");
        var tipoOrcamento = this.model.get("TipoOrcamento");
        var acao = "ALTERAR";

        global.ajax({
            url: "/Orcamento/AutorizarAcoesOrcamento",
            type: "post",
            data: {
                tipoOrcamento: tipoOrcamento,
                acao: acao
            },
            success: function (data) {

                if (data != null && data.HasErrors) {
                    return;
                }

                window.location.href = "/Orcamento/EditarOrcamento?numeroOrcamento=" + numeroPedido + "&tipoOrcamento=" + tipoOrcamento;
            }
        });
    },

    imprimirOrcamento: function(e) {
        var numero = this.model.get("Numero");

        if (window.imprimirTemplatesController) {
            window.imprimirTemplatesController.mostrarTemplates(e);
        }
    }

});